import { render } from "./ProductDetalleCliente.vue?vue&type=template&id=0a232d48&scoped=true"
import script from "./ProductDetalleCliente.vue?vue&type=script&lang=js"
export * from "./ProductDetalleCliente.vue?vue&type=script&lang=js"

import "./ProductDetalleCliente.vue?vue&type=style&index=0&id=0a232d48&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a232d48"]])

export default __exports__